export default "__VITE_ASSET__8lTsEUV$__"